const normalizePrice = value => {
  value = value.replace(/[^0-9.]/g, '');

  const sections = value.split('.');

  if (sections[0] !== '0' && sections[0] !== '00') {
    sections[0] = sections[0].replace(/^0+/, '');
  } else {
    sections[0] = '0';
  }

  if (sections[1]) {
    return sections[0] + '.' + sections[1].slice(0, 2);
  } else if (value.includes('.')) {
    return sections[0] + '.';
  } else {
    return sections[0];
  }
};

export default normalizePrice;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/utils/normalizePrice.js